import React from 'react';
import { SHIFT_TYPE_LABELS, WORK_TYPE_LABELS, DRIVE_TYPE_LABELS, formatDate, formatPhone } from '../utils/formatters';
import useModalAccessibility from '../hooks/useModalAccessibility';
import './ShiftDetailsModal.css';
import './DriverPostProfileModal.css';

const DriverPostProfileModal = ({ post, onClose }) => {
  const modalRef = useModalAccessibility(onClose);

  const getInitials = (name) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getVehicleTypes = () => {
    if (!post.vehicle_types) return [];
    return post.vehicle_types.split(',').map(v => v.trim());
  };

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        ref={modalRef}
        className="shift-details-modal driver-listing-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="driver-profile-title"
      >
        <button
          type="button"
          className="modal-close"
          onClick={onClose}
          aria-label="Close dialog"
        >
          &times;
        </button>

        {/* Profile Header */}
        <div className="listing-header">
          <div className="listing-icon driver-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
          <div className="listing-header-info">
            <h2 id="driver-profile-title" className="listing-name">{post.title}</h2>
            <div className="listing-meta">
              {post.driver_name && <span className="meta-item">{post.driver_name}</span>}
              {post.years_experience && (
                <span className="meta-item">{post.years_experience} yrs exp</span>
              )}
              {post.tlc_license_number && (
                <span className="meta-item">TLC #{post.tlc_license_number}</span>
              )}
              <span className="meta-item">{formatDate(post.created_at)}</span>
            </div>
          </div>
        </div>

        {(post.description || post.driver_bio) && (
          <p className="shift-description">
            {post.description}{post.description && post.driver_bio ? ' — ' : ''}{post.driver_bio}
          </p>
        )}

        <div className="section-divider" />

        <div className="details-grid">
          {post.shift_type && (
            <div className="detail-item">
              <span className="detail-label">Shift Type</span>
              <span className="detail-value">{SHIFT_TYPE_LABELS[post.shift_type] || post.shift_type}</span>
            </div>
          )}

          {getVehicleTypes().length > 0 && (
            <div className="detail-item">
              <span className="detail-label">Work Types</span>
              <span className="detail-value">
                {getVehicleTypes().map(v => WORK_TYPE_LABELS[v] || v).join(', ')}
              </span>
            </div>
          )}

          {post.drive_type && (
            <div className="detail-item">
              <span className="detail-label">Drive Type</span>
              <span className="detail-value">{DRIVE_TYPE_LABELS[post.drive_type] || post.drive_type}</span>
            </div>
          )}

          {post.wav ? (
            <div className="detail-item">
              <span className="detail-label">WAV Preferred</span>
              <span className="detail-value">Wheelchair Accessible Vehicle</span>
            </div>
          ) : null}

        </div>

        {(post.driver_phone || post.driver_email) && (
          <>
            <div className="section-divider" />
            <div className="fleet-section">
              <span className="fleet-label">Contact</span>
              <div className="fleet-info">
                <div className="fleet-avatar driver-avatar">
                  {getInitials(post.driver_name)}
                </div>
                <div className="fleet-details">
                  <div className="fleet-details-row">
                    <span className="fleet-name">{post.driver_name}</span>
                  </div>
                  <div className="fleet-details-row">
                    {post.driver_phone && (
                      <span className="fleet-contact-row">
                        <span className="contact-label">Phone:</span>
                        <a href={`tel:${post.driver_phone}`} className="fleet-contact-link">{formatPhone(post.driver_phone)}</a>
                      </span>
                    )}
                    {post.driver_email && (
                      <span className="fleet-contact-row">
                        <span className="contact-label">Email:</span>
                        <a href={`mailto:${post.driver_email}`} className="fleet-contact-link">{post.driver_email}</a>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="modal-actions">
          <button className="btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DriverPostProfileModal;
